import {
  news,
  NewsFilters,
  NewsListResponse,
  SingleNews,
} from '@toggle/toggle';

import { wretchRequest } from '~/utils/api-fetch/apiFetch';

export const fetchSingleNews = (id: string, signal?: AbortSignal) =>
  wretchRequest<SingleNews>(news.singleNews.path(id), {
    method: 'get',
    signal,
  });

export const fetchNewsFilters = () => {
  return wretchRequest<NewsFilters>(news.filters.path, {
    method: 'get',
  });
};

type FetchNewsFiltersV4Props = {
  query?: string;
  entities?: string[];
  markets?: string[];
  providers?: string[];
  highlights?: string[];
  date_range?: {
    from?: string;
    to?: string;
  };
  page?: {
    number: number;
    size?: number;
  };
  sortBy?: {
    field?: 'score' | 'published';
    desc?: boolean;
  };
};
export const fetchNewsArticles = (
  {
    query,
    entities,
    markets,
    providers,
    highlights,
    date_range,
    page,
    sortBy,
  }: FetchNewsFiltersV4Props,
  signal?: AbortSignal
) => {
  return wretchRequest<NewsListResponse>(news.newsSearch.path, {
    method: 'post',
    body: {
      query,
      filters: {
        ...(!!entities?.length && { entities }),
        ...(!!markets?.length && { markets }),
        ...(!!providers?.length && { providers }),
        ...(!!highlights?.length && { highlights }),
        date_range,
      },
      page,
      sort_by: sortBy,
    },
    signal,
  });
};
